import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap, take } from 'rxjs';
import { UserService } from '@core-session';
import { Resolve } from '@angular/router';
import { ProfileWebModel } from '@data-access';

@Injectable({
  providedIn: 'root',
})
export class UserProfileResolver implements Resolve<ProfileWebModel> {
  private userService = inject(UserService);

  resolve(): Observable<ProfileWebModel> {
    return this.userService.getProfile().pipe(
      take(1),
      switchMap((profile) => {
        this.userService.setCabinetAccess(profile);
        return of(profile);
      }),
    );
  }
}
